<template>
  <div>
    <template v-if="foodMenus.length === 0">
      <KkTutorial
        :description1="$t('pages.CompaniesFoodMenus.index.tutorial.noDataDescription1')"
        :description2="$t('pages.CompaniesFoodMenus.index.tutorial.noDataDescription2')"
        :img-path="tutorialImgPath"
        :tutorial-description="$t('pages.CompaniesFoodMenus.index.tutorial.description')"
        :available-service="$t('pages.CompaniesFoodMenus.index.tutorial.availableService')"
      >
        <template #buttonArea>
          <div class="c-button">
            <KkButton
              color="primary"
              :text="$t('pages.CompaniesFoodMenus.index.tutorial.register')"
              :to="{ name: 'CompaniesFoodMenusNew', params: { company_uuid: currentCompanyUuid }}"
            />
          </div>
        </template>
      </KkTutorial>
    </template>
    <template v-else>
      <template v-if="displayFoodMenu && displayGoogleError">
        <p class="errorTitle">{{ $t('pages.CompaniesLocationStore.foodMenu.error.title') }}</p>
        <div class="c-info--error">
          <div class="c-info__icon--error">
            <Icon name="iconQuestion" />
          </div>
          <div class="c-info__content--error">
            {{ $t('pages.CompaniesLocationStore.foodMenu.error.info1') }}<br>
            {{ $t('pages.CompaniesLocationStore.foodMenu.error.info2') }}
          </div>
        </div>
      </template>
      <template v-else>
        <Info>
          {{ $t('pages.CompaniesLocationStore.foodMenu.info1') }}
          <router-link v-if="displayFoodMenu && showOnlyOwnerAuthority" :to="{ name: 'CompaniesFoodMenusEdit', params: { company_uuid: currentCompanyUuid, id: displayFoodMenu.id }}">
            {{ $t('pages.CompaniesLocationStore.foodMenu.link') }}
          </router-link>
        </Info>
      </template>
      <p class="u-fwB">{{ $t('pages.CompaniesLocationStore.foodMenu.title') }}</p>
      <div v-if="showOnlyOwnerAuthority" class="c-select menuSelect">
        <select @change="$emit('change-food-menu', $event.target.value)">
          <option v-if="displayFoodMenu && !displayGoogleError" :value="displayFoodMenu.id">{{ displayFoodMenu.label }}</option>
          <option v-else :value="null">{{ $t('labels.placeholder.select') }}</option>
          <option v-for="(val, key) in foodMenusOptions" :key="key" :value="key">
            {{ val }}
          </option>
        </select>
      </div>
      <div v-if="displayFoodMenu && !displayGoogleError && !isDocomoPlan" class="targetService">
        <span class="targetService__title">{{ $t('pages.CompaniesLocationStore.foodMenu.targetServices') }}</span>
        <div class="targetService__icon">
          <KkSiteIcon v-for="(service, j) in displayFoodMenu.targetServices" :key="`foodMenu-${displayFoodMenu.id}-service-${j}`" :name="service" class="serviceIcon" />
          <button v-if="displayFoodMenu.targetServices.length" class="targetService__showPreview" @click="showPreview">{{ $t('pages.CompaniesLocationStore.foodMenu.showPreview') }}</button>
        </div>
      </div>
      <div v-if="displayFoodMenu && !displayGoogleError" class="category">
        <div v-for="(category, key) in displayFoodMenu" :key="`category-${key}`" class="category__container">
          <KkBox v-if="category.sections && category.sections.length > 0" :title="$t(`pages.CompaniesFoodMenus.edit.category.${key}`)" border>
            <template #content>
              <div v-for="(section, sectionIndex) in category.sections" :key="`section-${sectionIndex}`" class="foodMenuSection">
                <KkSection :title="section.label" selected-service="" :section="section" />
              </div>
            </template>
          </KkBox>
        </div>
        <div v-if="showOnlyOwnerAuthority" class="c-button c-button--right">
          <button class="c-button__item c-button__item--primary" @click="saveFoodMenu">{{ $t('labels.save') }}</button>
        </div>
      </div>
      <KkMultiServicePreviewModal
        v-if="showPreviewModal"
        :is-visible="showPreviewModal"
        :is-preview="true"
        :title="$t('pages.CompaniesLocationStore.foodMenu.preview.title')"
        :selected-services="displayFoodMenu.targetServices"
        :store-names="[]"
        :sections="foodMenuSections"
        @close="showPreviewModal = false"
      />
    </template>
  </div>
</template>

<script>
import Info from '../Info'
import Icon from '../Icon'
import { toNumberLocaleString } from '../../modules/localeString'
import { KkBox, KkButton, KkSiteIcon } from '../../components/base'
import { KkMultiServicePreviewModal, KkSection } from '../../domains/foodMenu'
import { menuCategories } from '../../domains/foodMenu/consts'
import { KkTutorial } from '../../components/projects'
import tutorialImgPath from '../../../../images/menus/tutorial.png'

export default {
  name: 'FoodMenu',
  components: {
    Info,
    Icon,
    KkBox,
    KkMultiServicePreviewModal,
    KkSection,
    KkTutorial,
    KkButton,
    KkSiteIcon
  },
  props: {
    displayFoodMenu: {
      type: Object
    },
    foodMenus: {
      type: Array,
      required: true
    },
    showOnlyOwnerAuthority: {
      type: Boolean,
      default: false
    },
    isDocomoPlan: {
      type: Boolean,
      default: false
    },
  },
  emits: ['change-food-menu', 'update-store-food-menu'],
  data() {
    return {
      showPreviewModal: false
    }
  },
  computed: {
    foodMenusOptions() {
      let obj = {}
      this.foodMenus.filter(v => (v.id !== this.displayFoodMenu?.id || this.displayFoodMenu?.error)).forEach(v => obj[v.id] = v.label)
      return obj
    },
    currentCompanyUuid() {
      return this.$route.params.company_uuid
    },
    foodMenuSections() {
      let allSections = []
      menuCategories.map(category => {
        allSections = allSections.concat(this.displayFoodMenu[category].sections)
      })
      return allSections
    },
    tutorialImgPath: () => tutorialImgPath,
    displayGoogleError() {
      return this.displayFoodMenu.targetServices.includes('google') && this.displayFoodMenu.error
    },
  },
  methods: {
    /**
     * 数値の3桁区切り
     * @param  { Number } value
     * @return { Number }
     */
    numberLocaleString(value) {
      return toNumberLocaleString(value)
    },
    serviceIconPath(service) {
      switch (service) {
      case 'google':
        return iconGooglePath
      case 'tabelog':
        return iconTabelogPath
      }
    },
    showPreview() {
      this.showPreviewModal = true
    },
    saveFoodMenu() {
      if (confirm(this.$t('pages.CompaniesLocationStore.foodMenu.confirm'))) this.$emit('update-store-food-menu', this.displayFoodMenu.id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../stylesheets/biz_spa/foundation/_var.scss';

.category {
  margin-top: 24px;
  &__container{
    margin-bottom: 16px;
  }
}
.menuSelect {
  width: 400px;
}
.targetService {
  margin-top: 24px;
  padding: 8px 16px;
  background-color: #F5F6F9;
  display: inline-block;
  border-radius: 4px;
  &__title {
    font-weight: bold;
    font-size: 12px;
  }
  &__icon{
    display: flex;
    margin-top: 8px;
  }
  &__showPreview {
    font-size: 12px;
    margin-left: 16px;
    text-decoration: underline;
  }
}
.serviceIcon {
  width: 32px;
  height: 32px;
  border: solid 1px #E4E7EB;
  border-radius: 4px;
  padding: 4px;
  background-color: #fff;
  &:not(:first-child) {
    margin-left: 8px;
  }
}
.foodMenuItem {
  width: 90%;
  margin-right: auto;
  margin-left: auto;
  &__container{
    display: flex;
    justify-content: space-between;
  }

  &__content {
    width: 100%;
    padding-right: 30px;

    &--above {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      font-weight: 700;
    }

    &--bottom {
      color: #9c9c9c;
    }
  }
  &__image {
    display: block;
    width: 20%;
    height: 100%;
    margin-right: 8px;
    object-fit: cover;
    border-radius: 4px;
  }
}

.foodMenuSection {
  margin-bottom: 16px;
}

.c-info__icon {
  &--error {
    padding: 8px 8px 0 4px;
    svg {
      fill: #FFF
    }
  }
}

.c-info{
  &--error {
    margin: 15px 0;
    display: inline-flex;
    align-items: center;
    padding: 8px;
    border-radius: 4px;
    background: #f5f6f9;
    background: $color-accent-primary;
  }
}

.c-info__content{
  &--error {
    font-size: 12px;
    font-weight: 700;
    line-height: 1.5;
    color: #FFF;
  }
}

.errorTitle {
  font-weight: 700;
  color: #ec5b7d;
}

.p-box {
  padding-bottom: 15px;
}

.availableService {
  font-weight: 700;
  margin-top: 10px;
}

.recommendBadge {
  background: #393a3e;
  border-radius: 12px;
  font-weight: bold;
  color: #FFF;
  font-size: 12px;
  padding: 4px 6px;
}
</style>
